import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { technicalPrinciples } from '../../mocks/company';

export default function Technology() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-gradient-to-r from-teal-600 to-teal-700">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">기술력</h1>
          <p className="text-lg md:text-xl text-white/90">
            현장 검증된 기술과 품질관리 시스템
          </p>
        </div>
      </section>

      {/* Technical Principles */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">기술 원리</h2>
            <p className="text-lg text-gray-600">
              매트리스개비온의 핵심 기술을 소개합니다.
            </p>
          </div>

          <div className="space-y-20">
            {technicalPrinciples.map((principle, index) => (
              <div key={index} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}>
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <div className="w-full h-96">
                    <img 
                      src={principle.image} 
                      alt={principle.title}
                      className="w-full h-full object-contain rounded-lg"
                    />
                  </div>
                </div>
                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  <div className="inline-block px-4 py-2 bg-teal-100 text-teal-700 text-sm font-semibold rounded-full mb-4">
                    기술 {index + 1}
                  </div>
                  <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
                    {principle.title}
                  </h3>
                  <p className="text-base text-gray-600 leading-relaxed">
                    {principle.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quality Control */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">품질관리</h2>
            <p className="text-lg text-gray-600">
              엄격한 품질관리 시스템으로 최고의 제품을 생산합니다.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="w-full h-96">
              <img 
                src="https://public.readdy.ai/ai/img_res/6a1efa9ccdb1464443efb9a7d0907f97.jpg" 
                alt="품질검사"
                className="w-full h-full object-cover rounded-lg shadow-lg"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">원자재 검사</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-checkbox-circle-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-semibold text-gray-900 mb-2">철선 품질 검사</h4>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      인장강도, 아연도금량 등 철선의 물리적 특성을 철저히 검사합니다.
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-checkbox-circle-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-semibold text-gray-900 mb-2">석재 품질 관리</h4>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      적정 크기와 강도를 가진 석재만을 선별하여 사용합니다.
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-checkbox-circle-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-semibold text-gray-900 mb-2">부자재 검증</h4>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      연결철물 등 모든 부자재의 품질을 검증합니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="lg:order-2">
              <div className="w-full h-96">
                <img 
                  src="https://readdy.ai/api/search-image?query=Manufacturing%20process%20of%20gabion%20mattress%20in%20modern%20factory%2C%20automated%20production%20line%2C%20wire%20mesh%20weaving%20machine%2C%20industrial%20manufacturing%2C%20quality%20production%2C%20professional%20factory%20environment%2C%20technical%20precision&width=800&height=600&seq=quality2&orientation=landscape" 
                  alt="생산관리"
                  className="w-full h-full object-cover rounded-lg shadow-lg"
                />
              </div>
            </div>
            <div className="lg:order-1">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">생산 공정 관리</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-checkbox-circle-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-semibold text-gray-900 mb-2">표준화된 생산 공정</h4>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      일관된 품질 유지를 위한 표준 작업 절차를 준수합니다.
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-checkbox-circle-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-semibold text-gray-900 mb-2">실시간 품질 모니터링</h4>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      생산 과정 전반에 걸쳐 실시간으로 품질을 모니터링합니다.
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-checkbox-circle-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-semibold text-gray-900 mb-2">최종 제품 검사</h4>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      출하 전 모든 제품에 대한 최종 품질 검사를 실시합니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Construction Site Support */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">현장 기술 지원</h2>
            <p className="text-lg text-gray-600">
              시공 현장에서의 기술 지원으로 성공적인 프로젝트를 완성합니다.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-file-text-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">설계 지원</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                현장 조건에 맞는 최적의 설계안을 제시하고 기술 자문을 제공합니다.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-tools-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">시공 지도</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                현장 시공 시 전문 기술진이 직접 방문하여 시공 지도를 실시합니다.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-customer-service-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">기술 상담</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                프로젝트 전 과정에서 발생하는 기술적 문제에 대한 신속한 상담을 제공합니다.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-book-open-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">교육 프로그램</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                시공 인력을 대상으로 한 교육 프로그램을 운영합니다.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-search-eye-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">품질 점검</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                시공 중 정기적인 품질 점검을 통해 시공 품질을 관리합니다.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">사후 관리</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                시공 완료 후에도 지속적인 사후 관리 서비스를 제공합니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">인증 및 특허</h2>
            <p className="text-lg text-gray-600">
              기술력을 인정받은 각종 인증 및 특허를 보유하고 있습니다.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-sm text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-award-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">품질경영시스템</h3>
              <p className="text-sm text-gray-600">ISO 9001 인증</p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-leaf-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">환경경영시스템</h3>
              <p className="text-sm text-gray-600">ISO 14001 인증</p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-file-shield-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">제품 인증</h3>
              <p className="text-sm text-gray-600">KC 인증 획득</p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-lightbulb-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">기술 특허</h3>
              <p className="text-sm text-gray-600">다수 특허 보유</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
